import {clsx} from 'clsx';
import {EvDateFns} from '../../components/ev-date-fns';
import {CalculationGoldListElement} from './calculation-gold.models';
import {EvFormattedNumber} from '../../components/ev-formatted-number';
import {EvButtonLink} from '../../form/EvButtonLink';
import {useCalculationGoldUpdateMutation} from './use-calculation-gold-update-mutation';
import {useCalculationGoldDeleteMutation} from './use-calculation-gold-delete-mutation';

interface Props {
  className: string;
  colSpanClass: string;
  element: CalculationGoldListElement;
  selected: () => void;
}

function hasFlag(flags: number, flagToCheck: number): boolean {
  return ((flags & flagToCheck) === flagToCheck);
}

export function CalculationGoldElement(props: Props) {
  const validated = hasFlag(props.element.entryType, 1);
  const priceAutoInserted = hasFlag(props.element.entryType, 8);
  const priceAutoUpdated = hasFlag(props.element.entryType, 16);
  const updateMutation = useCalculationGoldUpdateMutation({selected: props.element});
  const deleteMutation = useCalculationGoldDeleteMutation({selected: props.element});

  const validate: () => void = () => {
    updateMutation.mutate({
      date: props.element.date,
      price: props.element.priceNew ?? props.element.price,
      priceNew: null,
      entryType:
        priceAutoUpdated ?
          9 :
          props.element.entryType | 1,
    });
  };

  const remove: () => void = () => {
    if (confirm(`Soll der Goldpreis vom ${props.element.date} wirklich gelöscht werden?`)) {
      deleteMutation.mutate();
    }
  };

  return <>
    <div className={clsx(props.className)}>
      <div className="p-2">
        <EvDateFns date={props.element.date}/>
      </div>
      <div className="p-2 text-right">
        <EvFormattedNumber value={props.element.price} decimals={2} unit="€"/>
      </div>
      <div className="p-2">
        <EvButtonLink onClick={() => props.selected()} title="bearbeiten">
          <i className="fa fa-pencil"/>
        </EvButtonLink>
      </div>
      <div className="p-2 text-right">
        {props.element.priceNew === null ?
          null :
          <EvFormattedNumber value={props.element.priceNew} decimals={2} unit="€"/>}
      </div>
      <div className="p-2">
        {!priceAutoInserted || validated ? null :
          <EvButtonLink title="Preis Geprüft" onClick={() => validate()}>
            <i className="fa fa-check text-green-600"/>
          </EvButtonLink>
        }
      </div>
      <div className="p-2">
        {!priceAutoUpdated ? null :
          <EvButtonLink title="neueren Preis übernehmen" onClick={() => validate()}>
            <i className="fa fa-arrow-left text-green-600"/>
          </EvButtonLink>
        }
      </div>
      <div className="p-2">
        <EvButtonLink title="Preis löschen" onClick={() => remove()}>
          <i className="fa fa-trash-o text-red-600"/>
        </EvButtonLink>
      </div>
    </div>
  </>;
}
